  import './ClientsSection.css';
  import data from "./ClientsLogoData.json";
 

function ClientsSection({  }) {

 
return (




<section  className="clientsSection">

     {/* <img className=" " src="testimonials/quote.svg" alt={`Quote`} />   */}
     <div>
 <h2 className='color-blue-dark'>לוגואים שעוצבו כאן</h2>
  <h4 className='color-blue-dark'>התחלות עסקיות/רעיונות שמתבשלים</h4>
     </div>


      <div  className="all-client-logos">
{data?.map(({ clientName, logoPath }, index) =>
  logoPath ? (
    <div key={index} className="client-logo-div">
      <img
        src={logoPath}
        alt={clientName || `Client ${index + 1}`}
        className="client-logo-image"
      />
    </div>
  ) : null
)}

 </div>


</section >
);
}

export default ClientsSection;